import { __assign } from "tslib";
import React from 'react';
import { Text } from '@keen.io/ui-core';
import { Container, TextContainer } from './tooltip-item.styles';
import { theme as defaultTheme } from '../../theme';
var TooltipItem = function (_a) {
    var data = _a.data, _b = _a.theme, theme = _b === void 0 ? defaultTheme : _b;
    var tooltipSettings = theme.tooltip;
    return typeof data === 'string' ? (React.createElement(Text, __assign({ truncate: true }, tooltipSettings.labels.typography), data)) : (React.createElement(Container, null,
        React.createElement(Text, __assign({ truncate: true }, tooltipSettings.labels.typography),
            data.label,
            React.createElement("span", null, ":\u00A0")),
        React.createElement(TextContainer, null,
            React.createElement(Text, __assign({}, tooltipSettings.values.typography), data.value),
            data.change && (React.createElement(Text, __assign({}, tooltipSettings.labels.typography),
                "\u00A0",
                data.change)))));
};
export default TooltipItem;
